// Fancybox 5 wrapper (https://fancyapps.com/resources/integration/#react)
// A11Y-09: default English l10n is applied so lightbox toolbar buttons
// (Close, Next, Previous, Toggle zoom, Toggle fullscreen, Download,
// Toggle slideshow) always announce a name to screen readers. Callers may
// override any label by passing `options.l10n` or the `l10n` prop.
import React, { useRef, useEffect } from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import PropTypes from 'prop-types';

const DEFAULT_L10N = {
  CLOSE: "Close",
  NEXT: "Next",
  PREV: "Previous",
  MODAL: "You can close this modal content with the Esc key",
  TOGGLE_ZOOM: "Toggle zoom level",
  TOGGLE_THUMBS: "Toggle thumbnails",
  TOGGLE_SLIDESHOW: "Toggle slideshow",
  TOGGLE_FULLSCREEN: "Toggle full-screen mode",
  DOWNLOAD: "Download",
  ZOOMIN: "Zoom in",
  ZOOMOUT: "Zoom out",
};

export const Fancybox = (props) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    const delegate = props.delegate || "[data-fancybox]";
    const options = {
      ...props.options,
      l10n: { ...DEFAULT_L10N, ...(props.options?.l10n || {}), ...(props.l10n || {}) },
      on: {
        done: () => {
          props.fancyRef.current = true
        },
        close: () => {
          setTimeout(() => {
            props.fancyRef.current = false
          }, 200);
        }
      }
    }
    NativeFancybox.bind(container, delegate, options);

    return () => {
      NativeFancybox.unbind(container);
      NativeFancybox.close();
    };
  });

  return <div className="uploaded-image-row" ref={containerRef}>{props.children}</div>;
}

Fancybox.propTypes = {
  delegate: PropTypes.string,
  options: PropTypes.object,
  l10n: PropTypes.object,
  fancyRef: PropTypes.object,
  children: PropTypes.element
}
